import React from 'react'
import CV from '../../assets/Mitchelle-Muiruri_CV.pdf' 

const CTA = () => {

  return (
    
    <div className="cta">

        <a href={CV} download className='btn' style={{ marginRight: '20px'}}> Download CV</a>
        <a href="#contacts" className='btn btn-primary'>Contact Me</a>
    </div>
  )
}

export default CTA